module.exports = "/public/webpack/img/icon_help_categories_download_32951ee6f9b5194d4909ac952d4c3aa347.png";